module.exports = __webpack_public_path__ + "static/img/label-03.b2ddd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/label-03.png
// module id = Llfi
// module chunks = 150